var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1768 0.0117188C16.7878 0.245662 20.4541 4.05836 20.4541 8.72754V15.2725C20.4541 20.0923 16.5474 23.9999 11.7275 24L11.2783 23.9883C6.66703 23.7546 3 19.9418 3 15.2725V8.72754C3 3.9076 6.9076 0 11.7275 0L12.1768 0.0117188ZM11.7275 1.52734C7.75109 1.52734 4.52734 4.75109 4.52734 8.72754V15.2725C4.52734 19.2489 7.75109 22.4727 11.7275 22.4727C15.7039 22.4725 18.9277 19.2488 18.9277 15.2725V8.72754C18.9277 4.75118 15.7039 1.52749 11.7275 1.52734ZM11.7266 3.27246C14.7388 3.27246 17.1813 5.71443 17.1816 8.72656V15.2725L17.1748 15.5527C17.0289 18.435 14.645 20.7266 11.7266 20.7266C8.71443 20.7262 6.27246 18.2847 6.27246 15.2725V8.72656C6.27284 5.71466 8.71467 3.27285 11.7266 3.27246ZM11.7266 4.36328C9.31716 4.36367 7.36366 6.31716 7.36328 8.72656V15.2725C7.36328 17.6822 9.31692 19.6354 11.7266 19.6357C14.1365 19.6357 16.0908 17.6824 16.0908 15.2725V8.72656C16.0904 6.31692 14.1363 4.36328 11.7266 4.36328ZM12.8184 15.2725H10.6367V13.0908H12.8184V15.2725ZM12.8184 10.9092H10.6367V8.72754H12.8184V10.9092Z",
    fill: "#3E7C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.7ce0a86dd20cefc38d164f671f2bc849.svg";
export { ForwardRef as ReactComponent };